var map = {
	"./img1.JPG": 99716,
	"./img2.JPG": 77523,
	"./img3.JPG": 29110,
	"./img4.JPG": 28413,
	"./img5.JPG": 28512,
	"./img6.JPG": 43247,
	"./img7.JPG": 56754,
	"./img8.JPG": 54025,
	"./img9.JPG": 14892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61800;